module.exports = __webpack_public_path__ + "img/2.6d171a41.png";